import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AdminLayout = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const [darkMode, setDarkMode] = useState(false); // Dark mode state
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // Sidebar collapse state
  const navigate = useNavigate();

  const toggleDarkMode = () => setDarkMode((prevMode) => !prevMode);
  const toggleSidebar = () => setSidebarCollapsed((prevState) => !prevState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // const fetchUsers = async () => {
  //   try {
  //     const meResponse = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/api/staff/me`,
  //       {
  //         withCredentials: true,
  //       }
  //     );
  //     // if (!meResponse.data?.success) {
  //     //   throw new Error("Authentication failed");
  //     // }
  //     if (
  //       !meResponse.data ||
  //       !meResponse.data.success ||
  //       !meResponse.data?.success
  //     ) {
  //       navigate("/login");
  //       return;
  //     }
  //   } catch (err) {
  //     if (err.response?.status === 401 || err.status === 401) {
  //       // If unauthorized, redirect to login
  //       navigate("/login");
  //       return;
  //     }
  //   }
  // };
  // useEffect(() => {
  //   fetchUsers();
  // }, []);

  
  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/staff/me`,
        { withCredentials: true }
      );

     if (
             !res.data ||
             !res.data.success ||
             !res.data?.success
           ) {
             navigate("/login", { replace: true });
             return;
           }
           // Check user role if needed (example)
           // if (response.data.role !== 'user') {
           //   throw new Error("Unauthorized access");
           // }
     
         } catch (err) {
           console.error("Authentication error:", err);
           
           // Redirect to login if unauthorized or any error occurs
           if (err.response?.status === 401 || err.status === 401) {
             navigate("/login", { replace: true });
           } else {
             // For other errors, you might want to show an error message
             navigate("/login", { replace: true });
           }
           return;
         } finally {
           setLoading(false);
         }
       };

  // useEffect(() => {
  //   fetchUsers();
  // }, []);

    useEffect(() => {
      fetchUsers();
      
      // Optional: Set up an interval to check authentication periodically
      const authCheckInterval = setInterval(fetchUsers, 15 * 60 * 1000); // Check every 15 minutes
      
      return () => clearInterval(authCheckInterval);
    }, [navigate]);
    
  return (
    // <div className={`user-layout ${darkMode ? "dark" : "light"}`}>
    <div className="user-layout">
      {/* Sidebar */}
      <Sidebar darkMode={darkMode} collapsed={sidebarCollapsed} />

      {/* Navbar and Main Content */}
      <div className={`layout-content ${sidebarCollapsed ? "collapsed" : ""}`}>
        <Navbar
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
          toggleSidebar={toggleSidebar} // Pass toggleSidebar to Navbar
        />
        <main className="main-content">
          <ToastContainer position="top-right" autoClose={5000} />
          <Outlet />
        </main>
        {/* <Footer/> */}
      </div>
    </div>
  );
};

export default AdminLayout;
